import React, { useState, useEffect } from 'react';
import './frontend/AdminApp.css';
import Login from './frontend/pages/Login';
import AdminPanel from './frontend/components/AdminPanel';

function AdminPanelApp() {
  const [user, setUser] = useState(null);

  useEffect(() => {
  const storedUser = localStorage.getItem('user');
  const storedToken = localStorage.getItem('token');

  if (storedUser && storedToken) {
    const parsedUser = JSON.parse(storedUser);

    if (parsedUser.role === 'admin') {
      setUser(parsedUser);
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setUser(null);
    }
  } else {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  }
}, []);

  const handleLoginSuccess = (userData) => {
  if (userData?.role !== 'admin') {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    return;
  }

  setUser(userData);
};

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <div className="admin-app-shell">
      {user && localStorage.getItem('token') && user.role === 'admin' ? (
        <>
          <nav className="topbar">
            <div className="topbar-inner">
              <div className="topbar-brand-wrap">
                <div className="topbar-brand">BookPoint Admin</div>
                <div className="topbar-subtitle">Контрола на корисници, планови и претплати</div>
              </div>

              <div className="topbar-user-area">
                <div className="topbar-user-text">
                  <span className="topbar-user-label">Добредојде</span>
                  <span className="topbar-user-name">{user.name}</span>
                </div>

                <div className="topbar-actions">
                  <button
                    className="topbar-btn topbar-btn-secondary"
                    onClick={() => window.dispatchEvent(new CustomEvent('openReportedIssues'))}
                  >
                    Пријавени проблеми
                  </button>

                  <button onClick={handleLogout} className="topbar-btn topbar-btn-logout">
                    Одјава
                  </button>
                </div>
              </div>
            </div>
          </nav>

          <main className="admin-main-area">
            <div className="admin-content-wrap">
              <AdminPanel />
            </div>
          </main>
        </>
      ) : (
        <Login onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
}

export default AdminPanelApp;
